import {twMerge} from '@sdox/utils'

import {GalleryItem} from './GalleryItem'
import {Slideshow} from '../Slideshow'

import type {SlideshowProps} from '../Slideshow'

export interface MediaStreamProps {
  className?: string
  items?: SlideshowProps['items']
}

export const MediaStream = ({className, items = []}: MediaStreamProps) => {
  return (
    <Slideshow items={items}>
      {({show}) => (
        <div className={twMerge('@container/block', className)}>
          <div
            className={twMerge(
              'no-pullout-rounded-md pullout-rounded-lg grid gap-spacing-2 overflow-hidden',
              'grid-cols-2 @block-large:grid-cols-3',
            )}
          >
            {items?.map(({src, placeholderSrc}, index) => (
              src ? (
                <GalleryItem
                  key={index}
                  index={index}
                  src={src}
                  placeholderSrc={placeholderSrc}
                  imagesLength={items.length}
                  onClick={() => show(index)}
                  counterClassName={'hidden'}
                  expandIndicatorClassName={'opacity-0 duration-300 group-hover:opacity-100'}
                />
              ) : null
            ))}
          </div>
        </div>
      )}
    </Slideshow>
  )
}
